import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-2xl lg:max-w-7xl mx-auto space-y-12" }
const _hoisted_2 = { class: "flex overflow-x-auto whitespace-nowrap -mb-[1px]" }
const _hoisted_3 = ["onClick"]

import { ref, computed, watch } from "vue";
import type { FullWidthTabsWithUnderlineProps } from "./FullWidthTabsWithUnderlineProps";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import TabsHeader from "../components/TabsHeader.vue";
import TabsContent from "../components/TabsContent.vue";
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import EditableElement from "@/views/page/EditableElement.vue";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'FullWidthTabsWithUnderline',
  props: {
    block: {},
    pageColors: {},
    scrollAnimationType: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "49a8e5c4": (styleValues.value.text),
  "2b088460": (styleValues.value.brand)
}))

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

const activeTab = ref<number>(dataValues.value.tabs.data.items[0]?.id || 1);

const handleTabClick = (tabId: number) => {
    activeTab.value = tabId;
};

const activeTabContent = computed(() =>
    dataValues.value.tabs.data.items.find((tab) => tab.id === activeTab.value)
);

// Watch for changes in tabs data and reset active tab if current one is deleted
watch(
    () => dataValues.value.tabs.data.items,
    (newTabs) => {
        // Check if the currently active tab still exists
        const currentTabExists = newTabs.some((tab) => tab.id === activeTab.value);

        // If current tab doesn't exist and there are tabs available, set to first tab
        if (!currentTabExists && newTabs.length > 0) {
            activeTab.value = newTabs[0].id;
        }
    },
    { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    backgroundColor: styleValues.value.background,
    scrollAnimationType: _ctx.scrollAnimationType
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TabsHeader, {
              title: dataValues.value.title,
              description: dataValues.value.description,
              titleTextColor: styleValues.value.text,
              descriptionTextColor: styleValues.value.text,
              blockId: _ctx.block.id
            }, null, 8, ["title", "description", "titleTextColor", "descriptionTextColor", "blockId"]),
            (dataValues.value.tabs.data.items.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle({ borderColor: styleValues.value.border }),
                  class: "border-b"
                }, [
                  _createElementVNode("nav", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.tabs.data.items, (tab) => {
                      return (_openBlock(), _createBlock(EditableElement, {
                        key: tab.id,
                        blockId: _ctx.block.id,
                        "field-name": `tabs_${tab.id}`,
                        hideable: false,
                        "on-select": () => handleTabClick(tab.id)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (handleTabClick(tab.id)),
                            class: _normalizeClass(["tab-button flex-1 pb-4 px-4 transition-colors duration-200 cursor-pointer border-b-[2px] border-transparent text-center", { active: activeTab.value === tab.id }])
                          }, _toDisplayString(tab.label), 11, _hoisted_3)
                        ]),
                        _: 2
                      }, 1032, ["blockId", "field-name", "on-select"]))
                    }), 128))
                  ])
                ], 4))
              : _createCommentVNode("", true),
            _createVNode(TabsContent, {
              activeTabContent: activeTabContent.value,
              tabTitleTextColor: styleValues.value.text,
              tabDescriptionTextColor: styleValues.value.text,
              blockId: _ctx.block.id,
              fieldName: `tabs_${activeTabContent.value?.id}`,
              hideable: false
            }, null, 8, ["activeTabContent", "tabTitleTextColor", "tabDescriptionTextColor", "blockId", "fieldName"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "backgroundColor", "scrollAnimationType"]))
}
}

})